import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import {
  AppBar,
  IconButton,
  Toolbar,
  MenuItem,
  Button,
  TextField,
  Grid,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
} from "@mui/material";
import { useStateContext } from "../../../context/ContextProvider";
import axios from "axios";
import baseUrl from "../../../config/baseUrl";

const Header = (props) => {
  const auth = sessionStorage.getItem("user");
  const Navigate = useNavigate();
  const { setIsLoginUser, setDropdownMerchant, dropdownMerchant, isLiveMode, setIsLiveMode } =
    useStateContext();
  const [ownAccounts, setOwnAccounts] = useState([]);
  const [defaultvalue, setDefaultvalue] = useState("");
  const [allAccount, setAllAccount] = useState([]);
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [remainingDays, setRemainingDays] = useState(7);

  const userName = sessionStorage.getItem("userName");
  const accoutType = sessionStorage.getItem("accoutType");

  const [showRecovery, setShowRecovery] = useState(false);

  const [formData, setFormData] = useState({
    token: auth,
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const logout = () => {
    sessionStorage.clear("user");
    sessionStorage.clear("role");
    sessionStorage.removeItem("passwordPopupShown");
    setIsLoginUser("");
    Navigate("/DepositPortal");
  };

  useEffect(() => {
    const fetchAccountDetails = async () => {
      try {
        const config = {
          headers: {
            "content-type": "multipart/form-data",
            Authorization: `Bearer ${auth}`,
          },
        };
        const result = await axios.post(`${baseUrl}/details`, {}, config);
        if (result.data && result.data.data) {
          const ownId = result.data.id;
          setDefaultvalue(ownId);
          setOwnAccounts(result.data.data);
          setAllAccount(result.data.allAccount);
        }
      } catch (error) {
        console.error("Error fetching account details:", error);
      }
    };

    const checkPasswordAge = async () => {
      try {
        const config = {
          headers: {
            "content-type": "multipart/form-data",
            Authorization: `Bearer ${auth}`,
          },
        };

        const res = await axios.post(`${baseUrl}/userPasswordDate`, {}, config);
        const lastUpdated = new Date(res.data.lastUpdated);
        const today = new Date();

        const daysSinceUpdate = Math.floor(
          (today.getTime() - lastUpdated.getTime()) / (1000 * 60 * 60 * 24)
        );

        const remaining = 90 - daysSinceUpdate;
        setRemainingDays(remaining);

        const todayKey = today.toISOString().slice(0, 10); // e.g., "2025-07-11"
        const shownDate = sessionStorage.getItem("passwordPopupShownDate");

        // 🔒 Last 2 days and beyond: always show popup, no skip
        if (remaining <= 2) {
          setShowPasswordPopup(true);
        }

        // 📅 Show once per day if in last 7 days but not last 2
        else if (remaining <= 7 && remaining > 2) {
          if (shownDate !== todayKey) {
            setShowPasswordPopup(true);
            sessionStorage.setItem("passwordPopupShownDate", todayKey);
          }
        }
      } catch (err) {
        console.error("Failed to fetch password update date:", err);
      }
    };

    fetchAccountDetails();
    checkPasswordAge();
  }, []);

  const handleChangePassword = async () => {
    if (
      !formData.oldPassword ||
      !formData.newPassword ||
      !formData.confirmPassword
    ) {
      alert("All fields are required.");
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      alert("New password and confirm password do not match.");
      return;
    }

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth}`,
        },
      };

      const response = await axios.post(
        `${baseUrl}/changePassword-merchant`,
        formData,
        config
      );

      if (response.status === 200) {
        alert("Password changed successfully.");
        sessionStorage.clear("user");
        sessionStorage.clear("role");
        sessionStorage.removeItem("passwordPopupShown");
        setIsLoginUser("");
        Navigate("/DepositPortal");
      } else {
        alert(response.data.message || "Password change failed.");
      }
    } catch (error) {
      console.error("Change Password Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <AppBar sx={props.sx} elevation={0} className={props.customClass}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="menu"
            onClick={props.toggleMobileSidebar}
            sx={{ display: { lg: "none", xs: "inline" } }}
          >
            <MenuOutlinedIcon width="20" height="20" />
          </IconButton>

          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ flexWrap: "nowrap" }}
          >
            {/* Dropdown */}
            {(accoutType === "1" || accoutType === "3") && (
              <Box sx={{ mr: 2, flexShrink: 0 }}>
                <TextField
                  select
                  label="Merchant"
                  value={dropdownMerchant}
                  onChange={(e) => setDropdownMerchant(e.target.value)}
                  size="small"
                  sx={{
                    width: { xs: 140, sm: 160 },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "35px",
                      height: "40px",
                    },
                  }}
                >
                  <MenuItem value={defaultvalue}>OWN ACCOUNT</MenuItem>
                  <MenuItem value={allAccount}>ALL ACCOUNTS</MenuItem>
                  {ownAccounts.length === 0 ? (
                    <MenuItem disabled>No Submerchant</MenuItem>
                  ) : (
                    ownAccounts.map((acc) => (
                      <MenuItem key={acc.id} value={acc.id}>
                        SUB- ({acc.id}) {acc.name}
                      </MenuItem>
                    ))
                  )}
                </TextField>
              </Box>
            )}

            {/* <Box display="flex" alignItems="center" sx={{
              gap: "5px"
            }}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, minWidth: "32px", textAlign: "right", color: '#D2042D', fontSize: "12px" }}
              >
                TEST
              </Typography>
              <Switch
                checked={isLiveMode === "1"}
                onChange={(e) => {
                  const newMode = e.target.checked ? "1" : "0";
                  setIsLiveMode(newMode);
                  sessionStorage.setItem("isLiveMode", newMode);
                }}
                sx={{
                  width: 40,
                  height: 20,
                  padding: 0,
                  "& .MuiSwitch-switchBase": {
                    padding: 0.5,
                    "&.Mui-checked": {
                      transform: "translateX(20px)",
                      color: "#fff",
                      "& + .MuiSwitch-track": {
                        backgroundColor: "#4CAF50", // Green when ON
                        opacity: 1,
                      },
                    },
                  },
                  "& .MuiSwitch-thumb": {
                    width: 12,
                    height: 12,
                    backgroundColor: "#fff",
                    boxShadow: "0px 2px 3px rgba(0,0,0,0.3)",
                  },
                  "& .MuiSwitch-track": {
                    borderRadius: 14,
                    backgroundColor: "#D2042D", // Red when OFF
                    opacity: 1,
                  },
                }}
              />
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, minWidth: "32px", textAlign: "left", color: "#4CAF50", fontSize: "12px" }}
              >
                LIVE
              </Typography>
            </Box> */}

            {/* User Name */}
            {/* <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                mr: 2,
                color: "#1caae8",
                display: { xs: "none", sm: "block" },
                flexShrink: 0,
                marginLeft: "auto",
              }}
            >
              {userName}
            </Typography> */}

            {/* Logout Button */}
            <Button
              onClick={logout}
              variant="outlined"
              color="error"
              sx={{
                display: "flex",
                alignItems: "center",
                borderRadius: 2,
                px: { xs: 1.5, sm: 2 },
                py: { xs: 0.5, sm: 1 },
                gap: { xs: 0.5, sm: 1 },
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                fontWeight: 600,
                textTransform: "none",
                whiteSpace: "nowrap",
                minWidth: "auto",
              }}
            >
              <LogoutOutlinedIcon fontSize="small" />
              <Box
                component="span"
                sx={{ display: { xs: "none", sm: "inline" } }}
              >
                Logout
              </Box>
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>

      {/* Password Expiry Warning Popup */}
      <Dialog
        open={showPasswordPopup}
        maxWidth="xs"
        fullWidth
        onClose={(e, reason) => {
          if (remainingDays > 2 && reason !== "backdropClick") {
            setShowPasswordPopup(false);
          }
        }}
        disableEscapeKeyDown={remainingDays <= 2}
        disableBackdropClick={remainingDays <= 2}
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: 10,
            border: "1px solid #e0e0e0",
            backgroundColor: "#ffffff",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            fontSize: 20,
            color: "#d32f2f",
            textAlign: "center",
            pb: 1,
            background: "linear-gradient(90deg, #fef0ef 0%, #ffffff 100%)",
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
          }}
        >
          {showRecovery ? '🔐 Recover Your Account' : '🔐 Password Expiry Alert'}
        </DialogTitle>

        <DialogContent sx={{ px: 3 }}>
          {!showRecovery ? (
            <>
              <Typography
                sx={{
                  fontSize: 15,
                  mb: 3,
                  textAlign: "center",
                  color: "#333",
                  lineHeight: 1.6,
                }}
              >
                {remainingDays <= 0 ? (
                  <>
                    <b>Password Expired:</b> Your password has expired.
                    <br />
                    Please change your password now or else you won't be able to
                    access the dashboard.
                  </>
                ) : remainingDays <= 2 && remainingDays > 0 ? (
                  <>
                    <b>Final Reminder:</b> Your password will expire in{" "}
                    <b>{remainingDays}</b> day{remainingDays !== 1 ? "s" : ""}.
                    <br />
                    Please change your password now or else you won't be able to
                    access the dashboard.
                  </>
                ) : (
                  <>
                    For security reason your password will expire in{" "}
                    <b>{remainingDays}</b> day{remainingDays !== 1 ? "s" : ""}.
                    <br />
                    Kindly update your password to avoid service interruption.
                  </>
                )}
              </Typography>

              <Box
                component="form"
                noValidate
                autoComplete="off"
                sx={{ display: "flex", flexDirection: "column", gap: 2 }}
              >
                <TextField
                  label="Current Password"
                  type="password"
                  fullWidth
                  size="small"
                  variant="outlined"
                  name="oldPassword"
                  value={formData.oldPassword}
                  onChange={handleChange}
                  InputProps={{
                    sx: { borderRadius: 2, backgroundColor: "#f9f9f9" },
                  }}
                />
                <TextField
                  label="New Password"
                  type="password"
                  fullWidth
                  size="small"
                  variant="outlined"
                  name="newPassword"
                  value={formData.newPassword}
                  onChange={handleChange}
                  InputProps={{
                    sx: { borderRadius: 2, backgroundColor: "#f9f9f9" },
                  }}
                />
                <TextField
                  label="Confirm New Password"
                  type="password"
                  fullWidth
                  size="small"
                  variant="outlined"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  InputProps={{
                    sx: { borderRadius: 2, backgroundColor: "#f9f9f9" },
                  }}
                />
              </Box>

              {/* <Typography
                variant="body2"
                sx={{
                  mt: 2,
                  textAlign: "center",
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "#1976d2",
                  float: "inline-end",
                  "&:hover": { color: "#125ea2" },
                }}
                onClick={() => setShowRecovery(true)}
              >
                Recover your account
              </Typography> */}
            </>
          ) : (
            <>
              <Typography
                sx={{
                  fontSize: 15,
                  mb: 2,
                  textAlign: "center",
                  color: "#333",
                }}
              >
                Just enter your registered email, and we’ll send you a recovery link to get you back in.
              </Typography>

              <Box
                component="form"
                noValidate
                autoComplete="off"
                sx={{ display: "flex", flexDirection: "column", gap: 2 }}
              >
                {/* <TextField
                  label="EMAIL"
                  name="email"
                  value={formData.email || ""}
                  onChange={handleChange}
                  autoComplete="email"
                  fullWidth
                  size="small"
                  variant="outlined"
                  InputProps={{
                    sx: { borderRadius: 2, backgroundColor: "#f9f9f9" },
                  }}
                /> */}
                <TextField
                  label="EMAIL"
                  fullWidth
                  name="email"
                  onChange={handleChange}
                  InputProps={{
                    sx: { borderRadius: 2, backgroundColor: "#f9f9f9" },
                  }}
                />
              </Box>

              <Typography
                variant="body2"
                sx={{
                  mt: 2,
                  textAlign: "center",
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "#1976d2",
                  float: "inline-end",
                  "&:hover": { color: "#125ea2" },
                }}
                onClick={() => setShowRecovery(false)}
              >
                Back to password change
              </Typography>
            </>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            pb: 3,
            pt: 2,
            justifyContent: showRecovery || remainingDays <= 2 ? "center" : "space-between",
          }}
        >
          {showRecovery ? (
            <>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: 2,
                  fontWeight: 600,
                  px: 3,
                  background: "linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)",
                  boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
                }}
                // onClick={handleRecoverySubmit}
              >
                SEND
              </Button>
            </>
          ) : remainingDays <= 2 ? (
            <>
              <Button
                onClick={logout}
                variant="outlined"
                color="error"
                sx={{
                  borderRadius: 2,
                  fontWeight: 600,
                  px: 3,
                }}
              >
                Logout
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: 2,
                  fontWeight: 600,
                  px: 3,
                  background: "linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)",
                  boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
                }}
                onClick={handleChangePassword}
              >
                Change Password
              </Button>
            </>
          ) : (
            <>
              <Button
                onClick={() => setShowPasswordPopup(false)}
                variant="outlined"
                color="inherit"
                sx={{
                  borderRadius: 2,
                  fontWeight: 500,
                  px: 2,
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: 2,
                  fontWeight: 600,
                  px: 3,
                  background: "linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)",
                  boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
                }}
                onClick={handleChangePassword}
              >
                Change Password
              </Button>
            </>
          )}
        </DialogActions>

      </Dialog>
    </>
  );
};

export default Header;
